
import { Link } from "react-router-dom";
import t1 from "./blogs/workwear-blog-banner.jpeg";
import t2 from "./blogs/flared-vs-block-heels.jpeg";
import t3 from "./blogs/the-one-exceptional-shoe.jpeg";
import "./BlogMainPage.css";

const articles = [
  {
    id: 1,
    image: t1,
    category: "Workwear styling",
    title: "Best Heels for Work for Women in India (2026 Guide)",
    author: "S. Paruthi",
    readTime: "5 min",
    date: "Apr 2026",
    link: "./blog/best-heels-for-work-india",
  },
  {
    id: 2,
    image: t2,
    category: "Heel structure",
    title: "Flared Heels vs. Block Heels: an honest comparison",
    author: "M. Gupta",
    readTime: "8 min",
    date: "Mar 2026",
    link: "./blog/flared-heels-vs-block-heels",
  },
  {
    id: 3,
    image: t3,
    category: "Modern form",
    title: "The slow fashion case for buying one exceptional shoe",
    author: "A. Anand",
    readTime: "7 min",
    date: "Mar 2026",
    link: "./blog/that-one-exceptional-shoe",
  },
];

function BlogTravelGrid() {
  return (
    <section className="travel-grid">

      <div className="section-header">
        <h2>Editorial notes</h2>
        <a href="/blog/all" className="view-all">Browse all →</a>
      </div>

      <div className="grid-wrapper">
        {articles.map((article) => (
          <article className="grid-card" key={article.id}>
            <div className="grid-card-img">
            <Link to={article.link} state={{ scrollTo: 'start' }}>  <img src={article.image} alt={article.title} /> </Link>
            </div>
            <p className="grid-card-category">{article.category}</p>
            <h3 className="grid-card-title">{article.title}</h3>
            <div className="grid-card-byline">
              <span>{article.author}</span>
              <span className="dot" />
              <span>{article.readTime} read</span>
              <span style={{ marginLeft: "auto" }}>{article.date}</span>
            </div>
          </article>
        ))}
      </div>

    </section>
  );
}

export default BlogTravelGrid;
